import {connect} from 'react-redux';
import React, {Component} from 'react';

class Info extends Component {
    static defaultProps = {
        idValue: '',
        keyPrefix: '',
        info: {}
    };

    render() {
        return (
            <div id={this.props.idValue ? this.props.idValue : ""} className="rent-info clearfix">
                <h2>{this.props.info.title}</h2>
                <div className="rent-info-items">
                    {this.props.info.items.map((item, index) =>
                        <div key={this.props.keyPrefix + index} className="rent-info-itm">
                            <div className="rent-info-itm-icon">
                                <img src={item.imgURL} alt=""/>
                            </div>
                            <div className="rent-info-itm-name">
                                {item.name}
                            </div>
                            <div className="rent-info-itm-value">{item.value}</div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {

    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Info);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/Info.js